import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TestimonialsSection = () => {
  const [activeTestimonial, setActiveTestimonial] = useState(0);

  const testimonials = [
  {
    id: 1,
    name: 'María González',
    role: 'Propietaria • Lote 150m²',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1fce8ddbe-1763300166968.png",
    imageAlt: 'Mujer peruana sonriente de mediana edad con cabello negro largo, vestida con blusa blanca profesional en ambiente luminoso',
    rating: 5,
    text: `Comprar en Residencial 3 Volcanes fue la mejor decisión para mi familia. La ubicación es perfecta, cerca de todo lo que necesitamos, y las vistas a los volcanes son espectaculares. El proceso de compra fue transparente y el equipo de Millennials nos apoyó en cada paso. ¡100% recomendado!`,
    date: '15/12/2025',
    investment: 'S/ 225,000'
  },
  {
    id: 2,
    name: 'Carlos Mendoza',
    role: 'Asesor Inmobiliario • Top Performer',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1fb553e73-1763300091568.png",
    imageAlt: 'Hombre peruano profesional de 35 años con cabello corto negro, traje gris oscuro y corbata azul, sonrisa confiada',
    rating: 5,
    text: `Como asesor, el programa de referidos de Millennials ha transformado mi vida. Las comisiones son excelentes y el sistema multinivel me permite generar ingresos pasivos. El CRM es muy completo y me ayuda a gestionar mis clientes de manera profesional. Ya llevo 15 ventas este año.`,
    date: '08/01/2026',
    investment: 'Comisiones: S/ 45,000'
  },
  {
    id: 3,
    name: 'Ana Quispe',
    role: 'Inversionista • 3 Lotes',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_19b7f77ca-1763293657165.png",
    imageAlt: 'Mujer peruana empresaria de 40 años con cabello negro recogido, blazer negro elegante, expresión segura y profesional',
    rating: 5,
    text: `Invertir en Residencial 3 Volcanes fue una decisión inteligente. La plusvalía de la zona es evidente y el proyecto está muy bien planificado. Ya he recuperado mi inversión inicial gracias a la reventa de dos lotes con 40% de ganancia. Altamente recomendado para inversionistas.`,
    date: '22/12/2025',
    investment: 'ROI: +40%'
  },
  {
    id: 4,
    name: 'Roberto Flores',
    role: 'Propietario • Lote 200m²',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1aa7d9ef6-1763296853575.png",
    imageAlt: 'Hombre peruano de 45 años con cabello canoso corto, camisa celeste casual, sonrisa amable en ambiente exterior',
    rating: 5,
    text: `Las amenidades del residencial superaron mis expectativas. La piscina, áreas verdes y seguridad 24/7 hacen que mi familia se sienta segura y cómoda. El financiamiento directo facilitó mucho la compra. Excelente proyecto de Millennials, muy profesionales.`,
    date: '03/01/2026',
    investment: 'S/ 300,000'
  }];


  const certifications = [
  {
    icon: 'Shield',
    title: 'Certificado SUNARP',
    description: 'Títulos registrados',
    color: 'primary'
  },
  {
    icon: 'Award',
    title: 'ISO 9001',
    description: 'Calidad certificada',
    color: 'success'
  },
  {
    icon: 'CheckCircle',
    title: 'Licencia Municipal',
    description: 'Proyecto aprobado',
    color: 'primary'
  },
  {
    icon: 'Building2',
    title: 'Millennials',
    description: '15 años experiencia',
    color: 'success'
  }];


  const handlePrevious = () => {
    setActiveTestimonial((prev) => prev === 0 ? testimonials?.length - 1 : prev - 1);
  };

  const handleNext = () => {
    setActiveTestimonial((prev) => prev === testimonials?.length - 1 ? 0 : prev + 1);
  };

  const currentTestimonial = testimonials?.[activeTestimonial];

  return (
    <section className="py-20 md:py-28 lg:py-36 bg-gradient-to-b from-orange-50/30 via-white to-blue-50/30 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 z-0">
        <div className="absolute top-20 left-10 w-96 h-96 bg-emerald-200/20 rounded-full blur-3xl" />
        <div className="absolute bottom-20 right-10 w-[500px] h-[500px] bg-orange-200/20 rounded-full blur-3xl" />
      </div>
      <div className="relative z-10 px-4 md:px-6 lg:px-8 max-w-7xl mx-auto">
        {/* Section Header */}
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}>

          <motion.div
            className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-gradient-to-br from-orange-600 to-red-600 mb-6 shadow-2xl border-2 border-orange-300"
            animate={{ rotate: [0, -5, 5, 0] }}
            transition={{ duration: 4, repeat: Infinity }}>

            <Icon name="MessageSquare" size={36} className="text-white" />
          </motion.div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-black text-gray-900 mb-6">
            Historias de <span className="bg-gradient-to-r from-orange-600 to-red-600 bg-clip-text text-transparent">Éxito</span>
          </h2>
          <p className="text-xl md:text-2xl text-gray-700 font-semibold max-w-3xl mx-auto">
            Más de 500 familias ya confiaron en nosotros 🌟
          </p>
        </motion.div>

        {/* Main Testimonial Card */}
        <div className="max-w-5xl mx-auto mb-16">
          <AnimatePresence mode="wait">
            <motion.div
              key={activeTestimonial}
              initial={{ opacity: 0, x: 100 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -100 }}
              transition={{ duration: 0.5 }}
              className="relative">

              {/* Glow effect */}
              <div className="absolute -inset-4 bg-gradient-to-r from-orange-300/30 via-red-300/30 to-orange-300/30 rounded-3xl blur-2xl" />
              
              <div className="relative bg-white p-10 md:p-14 rounded-3xl border-3 border-orange-200 backdrop-blur-xl shadow-2xl">
                {/* Quote Icon */}
                <div className="absolute top-8 right-8 opacity-10">
                  <Icon name="Quote" size={80} className="text-orange-600" />
                </div>

                <div className="relative z-10">
                  {/* Rating */}
                  <div className="flex items-center gap-2 mb-6">
                    {[...Array(currentTestimonial?.rating)]?.map((_, i) =>
                    <motion.div
                      key={i}
                      initial={{ opacity: 0, scale: 0 }}
                      animate={{ opacity: 1, scale: 1 }}
                      transition={{ delay: i * 0.1 }}>

                        <Icon name="Star" size={28} className="text-amber-500 fill-amber-500" />
                      </motion.div>
                    )}
                  </div>

                  {/* Testimonial Text */}
                  <p className="text-xl md:text-2xl text-gray-800 leading-relaxed mb-8 font-semibold">
                    "{currentTestimonial?.text}"
                  </p>

                  {/* Author Info */}
                  <div className="flex items-center gap-6">
                    <div className="relative">
                      <div className="absolute inset-0 bg-gradient-to-br from-orange-500 to-red-600 rounded-full blur-md opacity-50" />
                      <Image
                        src={currentTestimonial?.image}
                        alt={currentTestimonial?.imageAlt}
                        className="relative w-20 h-20 rounded-full object-cover border-4 border-white shadow-xl" />

                    </div>
                    <div className="flex-1">
                      <h4 className="text-2xl font-heading font-black text-gray-900">
                        {currentTestimonial?.name}
                      </h4>
                      <p className="text-gray-600 font-bold">
                        {currentTestimonial?.role}
                      </p>
                      <div className="flex items-center gap-4 mt-2">
                        <span className="text-sm text-orange-600 font-black">{currentTestimonial?.investment}</span>
                        <span className="text-sm text-gray-500 font-semibold">{currentTestimonial?.date}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>

          {/* Navigation */}
          <div className="flex items-center justify-center gap-6 mt-10">
            <motion.button
              onClick={handlePrevious}
              className="w-14 h-14 rounded-full bg-gradient-to-br from-orange-600 to-red-600 text-white shadow-2xl hover:shadow-orange-300 transition-all flex items-center justify-center border-2 border-orange-300"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}>

              <Icon name="ChevronLeft" size={28} />
            </motion.button>

            <div className="flex gap-3">
              {testimonials?.map((_, index) =>
              <motion.button
                key={index}
                onClick={() => setActiveTestimonial(index)}
                className={`h-3 rounded-full transition-all ${
                index === activeTestimonial ?
                'w-12 bg-gradient-to-r from-orange-600 to-red-600 shadow-lg' : 'w-3 bg-gray-300 hover:bg-orange-400'}`
                }
                whileHover={{ scale: 1.2 }} />

              )}
            </div>

            <motion.button
              onClick={handleNext}
              className="w-14 h-14 rounded-full bg-gradient-to-br from-orange-600 to-red-600 text-white shadow-2xl hover:shadow-orange-300 transition-all flex items-center justify-center border-2 border-orange-300"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}>

              <Icon name="ChevronRight" size={28} />
            </motion.button>
          </div>
        </div>

        {/* Certifications */}
        <motion.div
          className="grid grid-cols-2 md:grid-cols-4 gap-6"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}>

          {certifications?.map((cert, index) =>
          <motion.div
            key={index}
            className="p-6 rounded-2xl bg-white border-2 border-gray-300 hover:border-orange-500 hover:shadow-xl transition-all text-center group cursor-pointer"
            whileHover={{ y: -8, scale: 1.05 }}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.1 }}>

              <motion.div
              className={`inline-flex items-center justify-center w-16 h-16 rounded-xl bg-gradient-to-br ${
                cert?.color === 'success' ? 'from-emerald-500 to-green-600' : 'from-orange-500 to-red-600'
              } mb-4 group-hover:scale-110 transition-transform shadow-lg`}
              whileHover={{ rotate: 360 }}
              transition={{ duration: 0.6 }}>

                <Icon name={cert?.icon} size={32} className={`text-${cert?.color}`} />
              </motion.div>
              <h4 className="text-lg font-bold text-gray-900 mb-1">{cert?.title}</h4>
              <p className="text-sm text-gray-600">{cert?.description}</p>
            </motion.div>
          )}
        </motion.div>
      </div>
    </section>
  );

};

export default TestimonialsSection;